// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SttZ","comment":"styles_comment__-ZQmm"};